import { ReactNode } from 'react';
import clsx from 'clsx';
import { Card } from '@/components/ui/Card';

interface KpiStatCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  icon?: ReactNode;
  isLoading?: boolean;
}

export const KpiStatCard = ({ label, value, hint, icon, isLoading }: KpiStatCardProps) => (
  <Card className="flex flex-col gap-3">
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</span>
      {icon && (
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-50 text-brand-500 dark:bg-brand-950">
          {icon}
        </span>
      )}
    </div>
    <div
      className={clsx(
        'text-3xl font-semibold text-gray-900 dark:text-white',
        isLoading && 'h-9 w-24 animate-pulse rounded-md bg-gray-200 dark:bg-gray-800'
      )}
    >
      {!isLoading && value}
    </div>
    {hint && <span className="text-xs text-gray-400 dark:text-gray-500">{hint}</span>}
  </Card>
);
